import { render, staticRenderFns } from "./CustFeedStore.vue?vue&type=template&id=35f31a05&"
import script from "./CustFeedStore.vue?vue&type=script&lang=js&"
export * from "./CustFeedStore.vue?vue&type=script&lang=js&"
import style0 from "./CustFeedStore.vue?vue&type=style&index=0&id=35f31a05&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports